import { render, staticRenderFns } from "./MedicalData.vue?vue&type=template&id=238f1fb4&scoped=true"
import script from "./MedicalData.ts?vue&type=script&lang=ts&external"
export * from "./MedicalData.ts?vue&type=script&lang=ts&external"
import style0 from "./MedicalData.scss?vue&type=style&index=0&id=238f1fb4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238f1fb4",
  null
  
)

export default component.exports